import React, { useState } from 'react';
import './BetaAccess.css';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export default function BetaAccess() {
  const [selectedType, setSelectedType] = useState('-');
  const [industry,     setIndustry]     = useState('-');
  const [email,        setEmail]        = useState('');
  const [status,       setStatus]       = useState(null); // "ok" | "dup" | "err"
  const [showOptional, setShowOptional] = useState(false);

  const businessTypes = ['-', 'B2C', 'B2B', 'MIX'];
  const validEmail    = emailRegex.test(email);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const r = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, businessType: selectedType, businessCase: industry })
      });
      if (r.status === 409) return setStatus('dup');
      if (!r.ok)           throw new Error();
      setStatus('ok');
      setEmail('');
      if (typeof window !== 'undefined' && window.gtag_report_conversion) {
        window.gtag_report_conversion();
      }
    } catch {
      setStatus('err');
    }
  }

  return (
    <section className="beta-access">
      <h2 className="beta-title">GET YOUR STARTUP BLUEPRINT</h2>

      <form className="beta-form" onSubmit={handleSubmit}>
        <input
          type="email"
          className="email-input"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        {!showOptional && (
          <button
            type="button"
            className="toggle-optional"
            onClick={() => setShowOptional(true)}
          >For better results, add your industry &amp; type ↗</button>
        )}

        {showOptional && (
          <div className="top-inputs">
            <div className="business-type-selector">
              {businessTypes.map(t => (
                <button
                  key={t}
                  type="button"
                  className={`type-button ${t === selectedType ? 'active' : ''}`}
                  onClick={() => setSelectedType(t)}
                >{t}</button>
              ))}
            </div>

            <select
              className="industry-dropdown"
              value={industry}
              onChange={e => setIndustry(e.target.value)}
            >
              <option value="unknown">-</option>
              <option value="adtech">AdTech</option>
              <option value="agtech">AgTech / Agriculture</option>
              <option value="ai-ml">AI / ML</option>
              <option value="analytics">Analytics / Data</option>
              <option value="ar-vr">AR / VR</option>
              <option value="biotech">BioTech / Life Sciences</option>
              <option value="climate">Climate Tech / GreenTech</option>
              <option value="construction">Construction Tech</option>
              <option value="consumer-saas">Consumer SaaS</option>
              <option value="cybersecurity">Cybersecurity</option>
              <option value="devtools">Developer Tools</option>
              <option value="ecommerce">E-Commerce</option>
              <option value="edtech">EdTech</option>
              <option value="energy">Energy / Cleantech</option>
              <option value="fintech">FinTech</option>
              <option value="foodtech">FoodTech</option>
              <option value="gaming">Gaming / Esports</option>
              <option value="govtech">GovTech / CivicTech</option>
              <option value="hardware-iot">Hardware &amp; IoT</option>
              <option value="healthtech">HealthTech</option>
              <option value="hrtech">HR Tech</option>
              <option value="legaltech">LegalTech</option>
              <option value="logistics">Logistics / Supply‑Chain</option>
              <option value="manufacturing">Manufacturing / Industrial</option>
              <option value="marketplace">Marketplace / Platform</option>
              <option value="media">Media &amp; Entertainment</option>
              <option value="proptech">PropTech / Real Estate</option>
              <option value="robotics">Robotics</option>
              <option value="saas">SaaS (Horizontal)</option>
              <option value="sportstech">SportsTech</option>
              <option value="traveltech">TravelTech</option>
              <option value="other">Other</option>
            </select>
          </div>
        )}

        <button className="request-button" type="submit" disabled={!validEmail}>
          Start&nbsp;7‑Day&nbsp;Free&nbsp;Trial →
        </button>

        {status === 'ok' && <p className="success-message">Thanks! We’ll reach out soon.</p>}
        {status === 'dup' && <p className="warning-message">You’re already on the list.</p>}
        {status === 'err' && <p className="error-message">Oops—try again later.</p>}
      </form>

      <p className="privacy-note">100 % private. No email spam.</p>
    </section>
  );
}
